export default __webpack_public_path__ + "static/media/hht2_ep06_timeline_q04_a.d0413aec.png";